import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid } from './../app.config';
import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';
import { Router } from '@angular/router';

@Component({
  selector: 'ntc-usuarios-sistema',
  templateUrl: './usuarios-sistema.component.html',
  styleUrls: ['./usuarios-sistema.component.css']
})
export class UsuariosSistemaComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  editOptionsGridUsuarioSistema = null;
  colunasGridUsuarioSistema = null;
  usuarioSistema = null;
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  constructor(
    @Inject(Http) http: Http,
    private router: Router
  ) {
    this.usuarioSistema = new CustomStore({
      remove: function (key) {
        return http.delete(`${NTECH_API}/usuario-sistema/${encodeURIComponent(key.Id)}`).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/usuario-sistema/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });

    this.colunasGridUsuarioSistema = [
      {
        dataField: 'Id',
        dataType: 'string',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'Nome',
        dataType: 'string',
        caption: 'Nome',
        validationRules: [{
          type: 'required',
          message: 'Nome é obrigatório.'
        }]
      },
      {
        dataField: 'Login',
        dataType: 'string',
        caption: 'Login',
        validationRules: [{
          type: 'required',
          message: 'Login é obrigatório.'
        }]
      }
    ];

    this.editOptionsGridUsuarioSistema = {
      mode: GridConfig.gridMode, // form GridConfig.gridMode
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      popup: {
        title: 'Usuario Sistema',
        showTitle: true
      }
    };

  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  onEditingStart(e) {
    this.router.navigate([`/usuario-sistema/${e.data.Id}`]);
  }

  onInitNewRow(e) {
    this.router.navigate(['/usuario-sistema']);
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }

}



// WEBPACK FOOTER //
// ./src/app/usuarios-sistema/usuarios-sistema.component.ts